// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xXD-","col":"styles_col__1JU45"};